import { HTTP } from './http-common'
import { getAccessToken } from './auth-fn'
import { appConfig } from './config-api'

export {
    addLead,
    getItem,
    saveItem,
    saveNewItem,
    deleteItem,
    deleteItemRoof,
    deleteNewItem,
    uploadFile,
    getFile,
    getCalcdictionaryListData,
    calcdictGroupData,
    saveDictionaryCalc,
    deleteDictionaryCalc,
    getRoofPrices,
    saveRoofPrices,
}

function addLead (leadObj, captchaToken) {
    // /rest/userrequest/callback`, );
    // {
    //                 locId: this.$store.state.locationId,
    //                 utm: window.location.href,
    //                 phone: this.form.phone,
    //                 sourceName: window.sourceName,
    //                 name: this.form.name
    //             }
    const url = `/portal/rest/userrequest/callback`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...captchaToken && {'Captcha-Token': captchaToken},
        },
        body: JSON.stringify(leadObj),
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response)
        } else {
            return response
        }
    }).catch(function (error) {
        throw error
    })
}

function getItem (type, id) {
    const url = `/rest/${type}/getall`
    return HTTP.get(url).then(
      response => (id) ? response.data.find(item => item.id == id) : response.data,
    ).catch(error => {
        throw error
    })
}

function getRoofPrices (id) {
    const url = `/rest/roofwindow/${id}/prices`
    return HTTP.get(url)
        .then(response => response.data)
        .catch(error => {
            throw error
        })
}

function saveRoofPrices (pricesModel) {
    const url = `${appConfig.backendUrl}/worker/roofwindow/prices/save`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(pricesModel),
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response)
        } else {
            return response
        }
    }).catch(function (error) {
        throw error
    })
}

function saveItem (type, data) {
    const url = `${appConfig.backendUrl}/worker/${type}/save`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response)
        } else {
            return response
        }
    }).catch(function (error) {
        throw error
    })
}
function saveNewItem (type, data) {
    const url = `${appConfig.backendUrl}/rest/${type}/save`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response)
        } else {
            return response
        }
    }).catch(function (error) {
        throw error
    })
}
function deleteNewItem (type, data) {
    const url = `${appConfig.backendUrl}/rest/${type}/delete`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response)
        } else {
            return response
        }
    }).catch(function (error) {
        throw error
    })
}

function deleteItem (type, data) {
    const url = `${appConfig.backendUrl}/worker/${type}/delete`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    })
      .then(response => {
          return response.status === 200
      })
      .catch(error => {
          throw error
      })
}

function deleteItemRoof (type, data, id) {
    const url = `${appConfig.backendUrl}/worker/${type}/${id}/delete`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    })
      .then(response => {
          return response.status === 200
      })
      .catch(error => {
          throw error
      })
}

// файлы
function uploadFile (formData) {
    const url = `${appConfig.backendUrl}/worker/file/upload`
    return fetch(url, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
        },
        body: formData,
    }).then(response => {
        return response.json()
    })
}

function getFile (fileId) {
    return `${appConfig.backendUrl}/rest/file/getfile?fileId=` + fileId
}

//----------------------//
function getCalcdictionaryListData () {
    const url = '/rest/dict/listdict'
    const params = {}
    return HTTP.get(url, {
        params,
        headers: {},
    })
      .then(response => response.data)
      .catch(error => {
          throw error
      })
}

function calcdictGroupData (dictCode) {
    const url = '/rest/dict/listdictdata'
    const params = {
        dictCode: dictCode,
    }
    return HTTP.get(url, {
        params,
        headers: {},
    })
      .then(response => response.data)
      .catch(error => {
          throw error
      })
}

function saveDictionaryCalc (data) {
    const url = '/worker/dict/type/save'
    return HTTP.post(url,
      data, {
          headers: {
              Authorization: `Bearer ${getAccessToken()}`,
          },
      })
      .then(response => response.data)
      .catch(error => {
          throw error
      })
}

function deleteDictionaryCalc (data) {
    const url = '/worker/dict/type/delete'
    return HTTP.post(url,
      data, {
          headers: {
              Authorization: `Bearer ${getAccessToken()}`,
          },
      })
      .then(response => response.data)
      .catch(error => {
          throw error
      })
}
